module.exports = __webpack_public_path__ + "img/icon_bg9.d4429562.png";